// extracted by mini-css-extract-plugin
var _1 = "errorBanner_formErrorBanner__jBcSS";
export { _1 as "formErrorBanner" }
